import { render, staticRenderFns } from "./Displays.vue?vue&type=template&id=2b789344&scoped=true&"
import script from "./Displays.vue?vue&type=script&lang=js&"
export * from "./Displays.vue?vue&type=script&lang=js&"
import style0 from "./Displays.vue?vue&type=style&index=0&id=2b789344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b789344",
  null
  
)

export default component.exports